/* unplugin-vue-components disabled */import { ElCheckboxGroup as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/checkbox-group/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElButton as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElCheckbox as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1dd9081a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top"
};
const _hoisted_2 = {
  key: 0
};
import { Search } from '@element-plus/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'name'
    },
    keyword: {
      type: String,
      default: 'id'
    },
    placeholder: {
      type: String,
      default: '请输入关键字'
    },
    highlight: {
      type: String,
      default: '#3F6DF8'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['change'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const indeterminate = ref(false);
    const checkAll = ref(false);
    const checkedList = ref([]);
    const inputSearch = ref('');
    const onCheckAllChange = e => {
      let ids = [];
      if (e) {
        props.data.forEach(item => {
          ids.push(item[props.keyword]);
        });
      }
      checkedList.value = ids;
      emits('change', checkedList.value);
    };
    const handleChange = e => {
      handleSearch(e);
    };
    const handleSearch = key => {
      props.data.forEach(item => {
        if (key && (item[props.label].indexOf(key) > -1 || String(item[props.keyword]).indexOf(key) > -1)) {
          item.Highlight = true;
        } else {
          item.Highlight = false;
        }
      });
    };
    const handleSelect = val => {
      indeterminate.value = !!val.length && val.length < props.data.length;
      checkAll.value = val.length === props.data.length;
      emits('change', val);
    };
    watch(() => props.modelValue, val => {
      checkedList.value = Object.assign(val);
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.data, val => {
      if (val.length && val.length === props.modelValue.length) {
        checkAll.value = true;
      } else if (props.modelValue.length) {
        indeterminate.value = true;
      } else {
        checkAll.value = false;
        indeterminate.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = __unplugin_components_0;
      const _component_el_button = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_checkbox_group = __unplugin_components_3;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_checkbox, {
        disabled: __props.disabled,
        indeterminate: _unref(indeterminate),
        onChange: onCheckAllChange,
        modelValue: _unref(checkAll),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(checkAll) ? checkAll.value = $event : null)
      }, {
        default: _withCtx(() => [_createTextVNode(" 全选 "), !_ctx.$slots.default ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(已选择" + _toDisplayString(_unref(checkedList).length) + "个)", 1)) : _createCommentVNode("", true), _renderSlot(_ctx.$slots, "default")]),
        _: 3
      }, 8, ["disabled", "indeterminate", "modelValue"]), _createVNode(_component_el_input, {
        modelValue: _unref(inputSearch),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(inputSearch) ? inputSearch.value = $event : null),
        size: "small",
        placeholder: __props.placeholder,
        style: {
          "width": "200px",
          "margin-left": "20px"
        },
        onChange: handleChange
      }, {
        append: _withCtx(() => [_createVNode(_component_el_button, {
          icon: _unref(Search),
          onClick: _cache[1] || (_cache[1] = $event => handleSearch(_unref(inputSearch)))
        }, null, 8, ["icon"])]),
        _: 1
      }, 8, ["modelValue", "placeholder"])]), _createVNode(_component_el_checkbox_group, {
        disabled: __props.disabled,
        onChange: handleSelect,
        modelValue: _unref(checkedList),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(checkedList) ? checkedList.value = $event : null),
        class: "check-group"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, item => {
          return _openBlock(), _createElementBlock("div", {
            class: "flex",
            key: item[__props.keyword]
          }, [_createVNode(_component_el_checkbox, {
            label: item[__props.keyword]
          }, {
            default: _withCtx(() => [_createElementVNode("span", {
              class: "marginR10",
              style: _normalizeStyle({
                color: item.Highlight ? __props.highlight : ''
              })
            }, _toDisplayString(item[__props.label] || item.Email), 5)]),
            _: 2
          }, 1032, ["label"])]);
        }), 128))]),
        _: 1
      }, 8, ["disabled", "modelValue"])]);
    };
  }
});